import { useEffect } from "react";
import { mostrarNotif } from "./useNotificacoes";
import { avisoAssinatura } from "../utils/avisoAssinatura";

const isAndroidApp = () => window.Capacitor?.getPlatform?.() === "android";

// Aviso local de fim do teste grátis / da assinatura nos últimos 3 dias — só
// web/Electron. No Android o mesmo aviso já chega por push (Cloud Function
// verificarAssinaturas), então não duplica aqui. Mostra uma vez por dia
// restante (chave no localStorage), então abrir o app várias vezes no mesmo
// dia não repete.
export function useNotificacaoAssinatura(perfil, isento) {
  useEffect(() => {
    if (!perfil || isento || isAndroidApp()) return;
    const aviso = avisoAssinatura(perfil);
    if (!aviso) return;
    try {
      if (localStorage.getItem(aviso.chave)) return;
      localStorage.setItem(aviso.chave, "1");
    } catch { /* sem localStorage: avisa mesmo assim */ }
    mostrarNotif(aviso.title, aviso.body, { type: "assinatura_expirando" });
  }, [perfil, isento]);
}
